import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shorty',
  standalone: true
})
export class Shorty implements PipeTransform {

  public transform(value: string, length: number = 16): string {
    return value.length > length ? value.slice(0, length) + "..." : value;
  }

}